"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var CardContent_1 = __importDefault(require("./CardContent"));
var CardHeader_1 = __importDefault(require("./CardHeader"));
var CardFooter_1 = __importDefault(require("./CardFooter"));
var CardDivider_1 = __importDefault(require("./CardDivider"));
var react_2 = require("react");
var constant_1 = require("../../constant");
var createCardStyle = function (theme) { return (__assign(__assign({}, theme.content), { border: theme.border, borderRadius: theme.name === constant_1.DESIGN_SYSTEM ? 6 : 2, margin: 10 })); };
var Card = function (props) {
    var theme = react_1.useTheme();
    var cardStyle = react_2.useMemo(function () { return createCardStyle(theme); }, [theme]);
    return react_1.jsx("div", __assign({ css: cardStyle }, props));
};
exports.default = Object.assign(Card, { Content: CardContent_1.default, Header: CardHeader_1.default, Footer: CardFooter_1.default, Divider: CardDivider_1.default });
